import React from 'react';
import PropTypes from 'prop-types';

import './CommunityHeartIcon.scss';
import { constructCn } from '../../../utilities/helperFunctions';

const CommunityHeartIcon = ({ className, isActive }) => {
    const cn = constructCn(
        'component-Icons-CommunityHeartIcon',
        className,
        isActive && 'active',
        !isActive && 'inactive'
    );
    return (
        <svg
            className={cn}
            viewBox="0 0 30 40"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <circle id="circle-background" cx="15" cy="25" r="15" />
                <g
                    id="community-heart-fill"
                    transform="translate(3.000000, 16.000000)"
                >
                    <path
                        d="M19.6805996,0.183633224 C16.6980778,-0.618520811 13.0378683,1.54736073 12.1108099,4.6336626 C12.1108099,4.6336079 12.110758,4.6334985 12.110758,4.63338909 C11.3260041,1.40141508 7.39017709,-0.642261595 4.31940354,0.183633224 C1.248578,1.00958275 -0.60465512,4.29915824 0.180046726,7.53113225 C0.964748572,10.763161 5.27821792,14.1890545 11.6067671,19.7284795 C11.7566078,19.8596009 11.8248496,19.9240401 11.8872182,19.9621676 C11.9552521,20.003796 12.0386182,20.0123296 12.1116415,19.9814775 C12.1799352,19.9526494 12.2256203,19.8946103 12.3932361,19.7284795 C17.840412,14.3299675 23.0352026,10.763161 23.8199564,7.53113225 C24.6046583,4.29915824 22.7513732,1.00958275 19.6805996,0.183633224"
                        id="Fill-4"
                    />
                </g>
                <g
                    id="Group"
                    transform="translate(1.000000, 2.000000)"
                    strokeLinecap="round"
                    strokeWidth="2"
                >
                    <g>
                        <line
                            x1="0"
                            y1="4.375"
                            x2="1.75"
                            y2="7"
                            id="wink-one"
                        />
                        <line
                            x1="26.25"
                            y1="7"
                            x2="28"
                            y2="5.25"
                            id="wink-two"
                        />
                        <line
                            x1="18.375"
                            y1="3.5"
                            x2="19.25"
                            y2="0"
                            id="wink-three"
                        />
                        <line
                            x1="9.625"
                            y1="3.5"
                            x2="8.75"
                            y2="0"
                            id="wink-four"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

CommunityHeartIcon.propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
};

CommunityHeartIcon.defaultProps = {
    className: '',
    isActive: false,
};

CommunityHeartIcon.displayName = 'CommunityHeartIcon';

export default React.memo(CommunityHeartIcon);
